import React, {Component} from 'react';
import {connect} from 'react-redux';
import GameTeams from './game-teams';
import {Factory as GameTotalFactory} from './game-total/factory';
import {getGameTeamNames} from 'helpers/game-helper';
import LockedGameSpecification from 'specifications/locked-game-specification';

class Game extends Component {
    onClick(gameTeams) {
        const {clickOnGameCallback} = this.props;
        if (typeof clickOnGameCallback === 'function') {
            clickOnGameCallback(gameTeams);
        }
    }

    getClassName() {
        const {game, sportConfig} = this.props;

        const classNames = ['filter-box'];
        LockedGameSpecification.isSatisfiedBy({sportConfig, game}) && classNames.push('disabled-game');

        if (!game.isActive) {
            classNames.push('canceled');
        }

        return classNames.join(' ');
    }

    shouldGameDatetimeBeShown(game) {
        const {sportConfig} = this.props;
        const datetimeStatuses = ['delayed', 'scheduled'];

        return !sportConfig.isSportMlb() || inArray(game.status.toLowerCase(), datetimeStatuses);
    }

    getDatetime() {
        const {game} = this.props;

        if (this.shouldGameDatetimeBeShown(game)) {
            return (
                <div className="filter-box-bottom-holder">
                    {game.gameDate}
                    <div>{game.gameTime.toUpperCase()}</div>
                </div>
            );
        }

        const className = game.isActive ? '' : 'inactive-status';

        return (
            <div className="filter-box-bottom-holder">
                <div className={`status-text ${className}`}>{game.status}</div>
            </div>
        );
    }

    render() {
        const {game, sportConfig, clickOnTeamCallback} = this.props;
        const gameTeams = getGameTeamNames(game);
        const GameTotal = GameTotalFactory.getComponent(sportConfig);

        return (
            <div className={this.getClassName()}>
                <GameTeams game={game} clickOnTeamCallback={clickOnTeamCallback} />
                <button type="button" className="filter-box-bottom" onClick={(e) => ::this.onClick(gameTeams)}>
                    {this.getDatetime()}
                    <GameTotal game={game} />
                </button>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;

    return {
        sportConfig,
    };
}

const GameComponent = connect(mapStatesToProps)(Game);

export {GameComponent};
